import { PathLineProps } from "./types";

export const PathLine = ({ pathLinePoints, arrowPoints }: PathLineProps) => {
  return (
    <>
      {/* Draw path line connecting all positions */}
      <polyline
        points={pathLinePoints}
        stroke="#00B7FF" // Cyan Path
        strokeWidth="2"
        fill="none"
        opacity="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Path shadow for better visibility */}
      <polyline
        points={pathLinePoints}
        stroke="rgba(0,0,0,0.8)"
        strokeWidth="3"
        fill="none"
        opacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ zIndex: -1 }}
      />
      {/* Draw direction arrows between consecutive positions */}
      {arrowPoints.map((points, idx) => (
        <polygon
          key={`arrow-${idx}`}
          points={points}
          fill="#00ffe1"
          stroke="#000000"
          strokeWidth="0.5"
          opacity="0.8"
        />
      ))}
    </>
  );
};
